import { MARGIN_DATA, MARGIN_ERROR_DATA, MARGIN_HIDE_ERROR_DATA, MARGIN_START_LOADER, MARGIN_STOP_LOADER, } from "../interface/ICalculateMargin";
const initialState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const calculateMargin = (state = initialState, action) => {
    switch (action.type) {
        case MARGIN_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case MARGIN_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case MARGIN_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case MARGIN_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case MARGIN_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default calculateMargin;
